import { useState, useCallback } from 'react';

interface PulseState {
  isActive: boolean;
  x: number;
  y: number;
}

interface ScaleState {
  isActive: boolean;
  scale: number;
}

export const usePulseAnimation = () => {
  const [pulseState, setPulseState] = useState<PulseState>({
    isActive: false,
    x: 0,
    y: 0,
  });

  const [scaleState, setScaleState] = useState<ScaleState>({
    isActive: false,
    scale: 1,
  });

  const triggerPulse = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    // Trigger pulse animation
    setPulseState({
      isActive: true,
      x,
      y,
    });

    // Trigger scale animation
    setScaleState({
      isActive: true,
      scale: 0.9,
    });

    // Reset pulse after animation duration (100ms)
    setTimeout(() => {
      setPulseState(prev => ({ ...prev, isActive: false }));
    }, 100);

    // Reset scale after animation duration (100ms)
    setTimeout(() => {
      setScaleState(prev => ({ ...prev, scale: 1 }));
    }, 100);
  }, []);

  return { pulseState, scaleState, triggerPulse };
};
